webpackJsonp([263791100135453],{

/***/ 693:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/me_large.caad13df.jpg";

/***/ }),

/***/ 465:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var introMyself = exports.introMyself = "\nHello!\nI'm Thi\n";

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _me_large = __webpack_require__(693);
	
	var _me_large2 = _interopRequireDefault(_me_large);
	
	var _constants = __webpack_require__(465);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About() {
	    return _react2.default.createElement(
	        "div",
	        { style: { flexDirection: 'row', display: 'flex' } },
	        _react2.default.createElement(
	            "div",
	            { style: styles.bgImage },
	            _react2.default.createElement(
	                "div",
	                { style: styles.introContainer },
	                _react2.default.createElement(
	                    "span",
	                    { style: styles.text },
	                    "Hi!",
	                    _react2.default.createElement("br", null),
	                    "Thi is a mobile developer in a outsourcing company.",
	                    _react2.default.createElement("br", null),
	                    "At home, he is known as an indie app developer.",
	                    _react2.default.createElement("br", null),
	                    "He also have some experience with backend and design.",
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement("br", null),
	                    "If you would like to share something or interested in working with him, feel free to keep in touch.",
	                    _react2.default.createElement("br", null),
	                    "Peace! \uD83D\uDE4C",
	                    _react2.default.createElement("br", null)
	                )
	            )
	        )
	    );
	};
	
	var styles = {
	    introContainer: {
	        padding: 20,
	        position: 'absolute',
	        top: 0,
	        right: 0,
	        bottom: 0,
	        width: '45%',
	        height: '100%',
	        backgroundColor: 'rgba(255,255,255,0.6)',
	        minWidth: 320,
	        fontFamily: 'Verdana'
	    },
	    bgImage: {
	        backgroundImage: "url(" + _me_large2.default + ")",
	        width: 720,
	        height: 498,
	        backgroundSize: 'cover',
	        position: 'relative'
	    },
	    text: {
	        color: 'black'
	    }
	};
	exports.default = About;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-02f084bcf7d58d93f9de.js